import { render } from "./contenidoPrograma.vue?vue&type=template&id=575f23e4"
import script from "./contenidoPrograma.vue?vue&type=script&lang=js"
export * from "./contenidoPrograma.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__